<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="form-box">
        <div class="title">发布诉求</div>
        <el-form ref="form" :model="dataForm" size="large" label-width="200px" :rules="rules">
          <el-form-item label="诉求分类:" prop="quesClassification">
            <el-radio-group v-model="dataForm.quesClassification">
              <el-radio v-for="item in quesClassificationList" :key="item.cd" :label="item.cd">
                {{ item.nm }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="诉求主题:" prop="quesType">
            <el-radio-group v-model="dataForm.quesType">
              <el-radio v-for="item in quesTypeList" :key="item.cd" :label="item.cd">
                {{ item.nm }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="标题名称:" prop="quesDes">
            <el-input v-model="dataForm.quesDes" style="width: 270px" />
          </el-form-item>
          <el-form-item label="诉求详情:" prop="quesContent">
            <el-input v-model="dataForm.quesContent" type="textarea" :rows="5" style="width: 580px" />
          </el-form-item>
          <el-form-item label="姓名:" prop="name">
            <el-input v-model="dataForm.name" style="width: 270px" />
          </el-form-item>
          <el-form-item label="联系电话:" prop="phone">
            <el-input v-model="dataForm.phone" style="width: 270px" />
          </el-form-item>
        </el-form>
        <el-button type="primary" class="sub-btn" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data() {
    return {
      dataForm: {},
      serviceTypeList: [],
      quesClassificationList: [],
      quesTypeList: [],
      rules: {
        quesClassification: [{ required: true, message: '请选择诉求分类', trigger: 'change' }],
        quesType: [{ required: true, message: '请选择诉求主题', trigger: 'change' }],
        quesDes: [{ required: true, message: '请填写标题名称', trigger: 'blur' }],
        quesContent: [{ required: true, message: '请填写诉求描述', trigger: 'blur' }],
        name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请填写联系电话', trigger: 'blur' }],
      },
      breadcrumb: [
        {
          path: '/service',
          name: '服务诉求',
          meta: {
            title: '服务诉求',
          },
        },
        {
          path: '/service/add',
          name: '发起诉求',
          meta: {
            title: '发起诉求',
          },
        },
      ],
    }
  },
  mounted() {
    this.getEnum('ZzmhPersonQuesEn$QuesClassification', 'quesClassificationList')
    this.getEnum('ZzmhPersonQuesEn$QuesType', 'quesTypeList')
  },
  methods: {
    getEnum(code, key) {
      this.$http({ method: 'get', url: `/general/enum/list?cls=${code}` }).then((res) => {
        this[key] = res.data.list
      })
    },
    checkForm() {
      let pass
      this.$refs.form.validate((val) => {
        pass = val
      })
      return pass
    },
    submit() {
      if (!this.checkForm()) return
      let params = {
        ...this.dataForm,
      }
      this.$http({ method: 'post', url: '/zzmh/in/personQues/add', data: params }).then((res) => {
        this.$message.success('操作成功')
        this.$router.back()
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './add.less';
</style>
